module.exports = __webpack_public_path__ + "static/favicon-6bf6dde8a613f547acd0d1acbf75a49a.ico";